export const handleValidationErrors = errorFields =>
    errorFields.reduce((acc, { field, errors }) => {
        acc[field] = errors;
        return acc;
    }, {});

export const getErrorProps = (field, errors, touched) => {
    if (errors[field] && touched[field]) {
        return {
            error: true,
            helperText: errors[field][0]
        };
    }

    return {};
};

export const getFormikErrorProps = (field, errors, touched) => {
    if (errors[field] && touched[field]) {
        return {
            error: true,
            helperText: errors[field]
        };
    }

    return {};
};
